<template>
  <div>
    <div class="mobile_employer_header">
            <div class="mobile_logo_with_toggle_webs">
                        <b-link href="" :to="{name: 'HomeNew'}" class="logo my_custom_logo">
                        <img :src="webUrl+'logo.png'" class="jobseeker_logo" alt="Employer logo" width="130" height="36">
                        </b-link>
                    <!-- </span> -->
                    <span class="web_only_humberger hamburger"  id="hamburger-2" @click="mobileHumbergerWebsite">
                        <!-- <img :src="webUrl+'assets/employerImages/Vector.png'" @click="mobileHumbergerWebsite"> -->
                        <span class="line"></span>
                        <span class="line"></span>
                        <span class="line"></span>
                    </span>
            </div>
            <div class="mobile_navigation_menu_website">
                <ul>
                    <li class="home_link"><b-link :to="{ name: 'HomeNew' }">{{ $t('nav.home') }}</b-link></li>
                    <li @click="showHideMobileDropDownMenuEmployer"><p class="dropdown_custom_arrow main_menu_dropdown_mobile_view_employer">{{ $t('nav.for_jobseeker') }}<span class="material-icons-outlined">expand_more_outlined</span></p>
                        <div class="sub_menu_mobile_view_employer" style="display:none;">
                            <ul class="pb-0 pt-0">
                                <li><b-link href="" :to="{name: 'jobseekers3'}">{{ $t('nav.jobseekers') }}</b-link></li>
<!--                                  <li><b-link href="" :to="{name: 'signup'}">Signup</b-link></li>
                                <li><b-link href="" :to="{name: 'login'}">Login</b-link></li> -->
                                <li><b-link href="" :to="{name: 'allDailyPaidJoblisting'}">{{ $t('nav.part_time_jobs') }}</b-link></li>
                                <li><b-link href="" :to="{name: 'allJobsListing'}">{{ $t('nav.full_time_jobs') }}</b-link></li>
                                <li><b-link href="" to="/singapore-gig-mission">{{ $t('nav.gig_listings') }}</b-link></li>
                                <li><b-link href="" :to="{name: 'GigMissionsLanding'}">{{ $t('nav.gig_missions') }}</b-link></li>
                                <li><b-link href="" :to="{ name: 'ResumeBuilder' }" target=_blank>{{ $t('nav.resume_builder') }}</b-link></li>
                            </ul>
                        </div>
                    </li>
                    <li><b-link href="" :to="{name: 'employer3'}">{{ $t('nav.for_employer') }}</b-link></li>
                    <li><b-link href="" :to="{name: 'blog'}">{{ $t('nav.blog') }}</b-link></li>
                    <li><b-link href="" :to="{name: 'aboutUs'}">{{ $t('nav.about_us') }}</b-link></li>
                    <li>
                        <a href="#" @click="$bvModal.show('bv-modal-example')" class="mobile_login_register"
                        >{{ $t('nav.login_signup') }}</a
                        >
                    </li>
                </ul>
            </div>
          </div>
  </div>
</template>

<script>

export default{
    props: {
        is_gig: {
            type: Boolean,
            default: false
        }
    },
    data() {
		return {
            webUrl: process.env.VUE_APP_URL
        }
	},
	methods:{
        mobileHumbergerWebsite(){
            $('.mobile_navigation_menu_website').slideToggle();
            $('.mobile_login_register').click(function(){
                $('.mobile_navigation_menu_website').hide();
            });
        },
        showHideMobileDropDownMenuEmployer(){
            $('.sub_menu_mobile_view_employer').slideToggle('fast','swing');
        },
	},
    components:{

    },
	mounted()
    {


    }
}

</script>
